import NAVBAR from 'components/navbar';

function CupomParceiro(){
    return <>
    <NAVBAR />
    <h1>Cupom Parceiro</h1>
    </>
}
export default CupomParceiro;